import React, { useEffect, useState } from 'react'
import Title from '../../../components/common/Title';
import { Topbar } from '../../../components/include/Topbar';
import { useLocation, useParams } from 'react-router-dom';
// import { message } from '../../../redux/actions/toastActions';
// import { useDispatch } from 'react-redux';
import { Postdata } from '../../../helpers/api.service';
import HttpService from '../../../helpers/httpServices';
import Loader from '../../../components/common/Loader';
import { Convert_toSpace } from '../../../helpers/uttils';
import modules from '../../../helpers/adminModuleConfig';
import { toast } from 'sonner';
import { useCountryNavigate } from '../../../components/common/UseCountryNavigate';
const AddRole = () => {
    const [data, setData] = useState({
        name: "",
        permissions: []
    });
    const [refresh, setRefresh] = useState(false);
    const [errors, setErrors] = useState({});
    const params = useParams();
    const navigate = useCountryNavigate();
    const [loader, setLoader] = useState(false);
    const location = useLocation();
    // const navigate = useNavigate();
    // const dispatch = useDispatch();
    
    // Handle permission toggle with dependency rules
    // const handlePermissionChange = (moduleName, action) => {
    //     const permissionKey = `${action}_${moduleName}`;
    //     let updatedPermissions = [...data.permissions];

    //     if (updatedPermissions.includes(permissionKey)) {
    //         // If unchecking "view", remove all related permissions
    //         if (action === "view") {
    //             updatedPermissions = updatedPermissions.filter(p => !p.endsWith(`_${moduleName}`));
    //         } else {
    //             updatedPermissions = updatedPermissions.filter(p => p !== permissionKey);
    //         }
    //     } else {
    //         // If checking "edit" or "delete", ensure "view" is also checked
    //         if ((action === "edit" || action === "delete")) {
    //             const viewKey = `view_${moduleName}`;
    //             if (!updatedPermissions.includes(viewKey)) {
    //                 updatedPermissions.push(viewKey);
    //             }
    //         }
    //         updatedPermissions.push(permissionKey);
    //     }

    //     setData(prev => ({
    //         ...prev,
    //         permissions: Array.from(new Set(updatedPermissions)) // ensure uniqueness
    //     }));
    // };

    const handlePermissionChange = (moduleName, action) => {
        const permissionKey = `${action}_${moduleName}`;
        let updatedPermissions = [...data.permissions];

        const addPermission = (perm) => {
            if (!updatedPermissions.includes(perm)) {
                updatedPermissions.push(perm);
            }
        };

        const removePermission = (perm) => {
            updatedPermissions = updatedPermissions.filter(p => p !== perm);
        };

        if (updatedPermissions.includes(permissionKey)) {
            // Unchecking logic
            if (action === "view") {
                // Remove all permissions related to this module
                updatedPermissions = updatedPermissions.filter(p => !p.endsWith(`_${moduleName}`));
            } else {
                removePermission(permissionKey);
            }

            // Extra logic: if unchecking all education-related permissions, remove the dependent views
            if (moduleName === "Education") {
                const remainingEduPerms = updatedPermissions.filter(p => p.endsWith("_Education"));
                if (remainingEduPerms.length === 0) {
                    removePermission("view_Board_Management");
                    removePermission("view_School_Management");
                }
            }

        } else {
            // Checking logic
            if ((action === "edit" || action === "delete")) {
                const viewKey = `view_${moduleName}`;
                addPermission(viewKey);
            }
            addPermission(permissionKey);

            // Add dependent view permissions if module is education
            if (moduleName === "Education") {
                addPermission("view_Board_Management");
                addPermission("view_School_Management");
            }
        }
        console.log("Array.from(new Set(updatedPermissions))", Array.from(new Set(updatedPermissions)))
        setData(prev => ({
            ...prev,
            permissions: Array.from(new Set(updatedPermissions))
        }));
    };

    const validate = () => {
        const newErrors = {};

        const nameTrimmed = data.name.trim();
        const regex = /^[a-zA-Z\s\/\-']+$/; // allows alphabets, spaces, /, -, '

        if (!nameTrimmed) {
            newErrors.name = "Role name is required.";
        } else if (nameTrimmed.length < 3 || nameTrimmed.length > 30) {
            newErrors.name = "Role name must be between 3 and 30 characters.";
        } else if (!regex.test(nameTrimmed)) {
            newErrors.name = "Only letters, spaces, '/', '-', and apostrophes are allowed.";
        } else if (/^[\s]+$/.test(data.name)) {
            newErrors.name = "Only spaces are not allowed.";
        } else if (/^\d+$/.test(data.name)) {
            newErrors.name = "Numeric-only names are not allowed.";
        } else if (/\p{Emoji}/u.test(data.name)) {
            newErrors.name = "Emojis are not allowed.";
        }

        if (!(data.permissions.length > 0)) {
            newErrors.permissions = "At least one permission is required.";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = () => {
        if (!validate()) return;
        setLoader(true)
        const form = new FormData();
        if (params.id) form.append("id", params.id);
        form.append("name", data.name);

        if (data.permissions.length > 0) {
            data.permissions.forEach((e) => {
                form.append("permissions", e)
            })
        }

        Postdata(HttpService.school_role_add, form).then((res) => {
            if (res.status == 200) {
                toast.success(res.message);
                navigate("admin-role");
            }
            // dispatch(message(res.message))
            setLoader(false)
        })
    }

    const fetchData = () => {
        setLoader(true)
        Postdata(HttpService.school_role_show, { id: params.id }).then((res) => {
            if (res.status == 200) {
                setData({
                    name: res.data.name,
                    permissions: res.data.permissions
                })
                setRefresh(!refresh)
            }
            // else {
            //     dispatch(message(res.message));
            // }
            setLoader(false)
        })
    }


    useEffect(() => {
        if (location.state?.type === "edit") {
            fetchData()
        }
    }, []);

    if (loader) {
        return <Loader isClass="loader_fullscreen" />
    }
    return (
        <>
            <Title name={location.state?.type === "edit" ? "Edit Role" : "Add Role"} />
            <Topbar aerrow={true} title={location.state?.type === "edit" ? data.name : ""} />

            <div className="p-6 space-y-6 pr-0">
                {/* Role Name Input */}
                {(location.state?.type !== "edit") && <div className="max-w-md">
                    <label className="block mb-1 font-medium text-gray-700">
                        Enter Role <span className="text-red-500">*</span>
                    </label>
                    <input
                        type="text"
                        placeholder="Enter Your Role"
                        className="input-field"
                        value={data.name}
                        onChange={(e) => setData(prev => ({ ...prev, name: e.target.value }))}
                        disabled={location.state?.type === "edit"}
                    />
                    {errors.name && (
                        <span className="text-red-500 text-sm">{errors.name}</span>
                    )}
                </div>
                }

                {/* Permissions Table */}
                <div className="overflow-x-auto bg-white">
                    <table className="min-w-full ">
                        <thead className="">
                            <tr>
                                <th className="px-4 py-2 text-left ">Module</th>
                                {["Add/Update", "View", "Delete"].map(action => (
                                    <th key={action} className="px-4 py-2  text-center">{action}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {Object.entries(modules).map(([moduleName, actions]) => (
                                <tr key={moduleName} className="">
                                    <td className="px-4 py-2 ">{Convert_toSpace(moduleName)}</td>
                                    {actions.map(action => (
                                        <td key={action} className="px-4 py-2  text-center">
                                            <input
                                                type="checkbox"
                                                checked={data.permissions.includes(`${action}_${moduleName}`)}
                                                onChange={() => handlePermissionChange(moduleName, action)}
                                                className="accent-primary_main w-5 h-5 cursor-pointer "
                                            />
                                        </td>
                                    ))}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    {errors.permissions && (
                        <span className="text-red-500 text-sm">{errors.permissions}</span>
                    )}
                </div>
                <div className="w-full flex justify-center gap-3 mb-2 mt-4">
                    <button
                        type="submit"
                        className="button-field-primary"
                        style={{ width: "30%" }}
                        onClick={handleSubmit}
                    >
                        Submit
                    </button>
                </div>
            </div>
        </>
    )
}

export default AddRole